import React, { useState } from "react";
import styles from "./E-bookStore.module.css";

const EBookStore = () => {
  // Filter categories
  const categories = [
    { id: "all", name: "All E-Books", count: 3 },
    { id: "upsc", name: "UPSC Mathematics", count: 1 },
    { id: "bpsc", name: "BPSC Mathematics", count: 2 },
    { id: "csat", name: "CSAT", count: 0 },
    { id: "csir", name: "CSIR NET", count: 0},
    { id: "foundation", name: "Foundation", count: 0 }
  ];

  // E-books data with Instamojo links - coverIcon removed
  const eBooks = [
    // UPSC Mathematics (8 e-books)

    {
      id: 1,
      title: "UPSC Mathematics Optional - Practice Workbook For Paper I & II",
      author: "Asha Mam",
      category: "upsc",
      price: "₹3999",
      originalPrice: "₹3499",
      pages: 150,
      format: "PDF",
      language: "English",
      description: "Practice questions with varying difficulty levels",
      features: [
        "300+ practice questions",
        "Topic-wise exercises",
        "Detailed solutions",
        "Speed tests"
      ],
      color: "#0B5E42",
      instamojoLink: "https://www.instamojo.com/@exademy/upsc-workbook-vol2" // Replace with actual link
    },
    
    {
      id: 3,
      title: "BPSC Mathematics - Formula & Shortcut Book",
      author: "Prabhash Sir",
      category: "bpsc",
      price: "₹1999",
      originalPrice: "₹1099",
      pages: 50,
      format: "PDF",
      language: "Bilingual",
      description: "Quick reference with formulas and shortcut techniques for BPSC",
      features: [
        "400+ formulas",
        "Shortcut methods",
        "Quick revision notes",
        "Bilingual format"
      ],
      color: "#8B5CF6",
      instamojoLink: "https://www.instamojo.com/@exademy/bpsc-formulas" // Replace with actual link
    },
    {
      id: 4,
      title: "BPSC Mathematics - Mock Test Series (8 Tests)",
      author: "Prabhash Sir",
      category: "bpsc",
      price: "₹2599",
      originalPrice: "₹1999",
      pages: 70,
      format: "PDF",
      language: "Bilingual",
      description: "8 full-length mock tests as per BPSC examination pattern",
      features: [
        "8 practice tests",
        "BPSC pattern",
        "Solutions included",
        "Performance analysis"
      ],
      color: "#8B5CF6",
      instamojoLink: "https://www.instamojo.com/@exademy/bpsc-mock-tests" // Replace with actual link
    },
  ];

  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  // Filter e-books based on category and search
  const filteredEBooks = eBooks.filter((ebook) => {
    const matchesCategory = selectedCategory === "all" || ebook.category === selectedCategory;
    const matchesSearch = ebook.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          ebook.author.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Handle buy now click
  const handleBuyNow = (instamojoLink) => {
    window.open(instamojoLink, "_blank");
  };

  return (
    <div className={styles.ebookStore}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.container}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>
              <span className={styles.gradientText}>E-Book Store</span>
            </h1>
            <p className={styles.heroSubtitle}>
              Download high-quality study materials crafted by experts. Instant access after purchase.
            </p>
            
            {/* Search Bar */}
            <div className={styles.searchBar}>
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Search e-books by title or author..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className={styles.categoriesSection}>
        <div className={styles.container}>
          <div className={styles.categoriesGrid}>
            {categories.map((category) => (
              <button
                key={category.id}
                className={`${styles.categoryBtn} ${selectedCategory === category.id ? styles.categoryActive : ''}`}
                onClick={() => setSelectedCategory(category.id)}
              >
                {category.name}
                <span className={styles.categoryCount}>{category.count}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* E-Books Grid */}
      <section className={styles.ebooksSection}>
        <div className={styles.container}>
          <div className={styles.ebooksHeader}>
            <h2>
              {selectedCategory === "all" 
                ? "All E-Books" 
                : categories.find(c => c.id === selectedCategory)?.name}
            </h2>
            <span className={styles.ebooksCount}>{filteredEBooks.length} e-books available</span>
          </div>

          {filteredEBooks.length === 0 ? (
            <div className={styles.noResults}>
              <i className="fas fa-book-open"></i>
              <h3>No e-books found</h3>
              <p>Try adjusting your search or filter</p>
            </div>
          ) : (
            <div className={styles.ebooksGrid}>
              {filteredEBooks.map((ebook) => (
                <div key={ebook.id} className={styles.ebookCard}>
                  <div className={styles.ebookCardHeader} style={{ background: `linear-gradient(145deg, ${ebook.color}15, ${ebook.color}05)` }}>
                    <div className={styles.ebookFormat}>{ebook.format}</div>
                  </div>

                  <div className={styles.ebookCardBody}>
                    <h3>{ebook.title}</h3>
                    <p className={styles.ebookAuthor}>by {ebook.author}</p>
                    
                    <div className={styles.ebookMeta}>
                      <span><i className="fas fa-file-alt"></i> {ebook.pages} pages</span>
                      <span><i className="fas fa-language"></i> {ebook.language}</span>
                    </div>

                    <p className={styles.ebookDescription}>{ebook.description}</p>

                    <div className={styles.ebookFeatures}>
                      {ebook.features.map((feature, idx) => (
                        <span key={idx} className={styles.featureTag}>{feature}</span>
                      ))}
                    </div>
                  </div>

                  <div className={styles.ebookCardFooter}>
                    <div className={styles.priceSection}>
                      <span className={styles.originalPrice}>{ebook.originalPrice}</span>
                      <span className={styles.currentPrice}>{ebook.price}</span>
                    </div>
                    <button 
                      className={styles.buyBtn}
                      onClick={() => handleBuyNow(ebook.instamojoLink)}
                      style={{ background: ebook.color }}
                    >
                      Buy Now
                      <i className="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Features Section - Updated with 3 features (removed Free Updates) */}
      <section className={styles.featuresSection}>
        <div className={styles.container}>
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <i className="fas fa-bolt"></i>
              <h3>Instant Access</h3>
              <p>Download immediately after purchase</p>
            </div>
            <div className={styles.featureCard}>
              <i className="fas fa-mobile-alt"></i>
              <h3>Read Anywhere</h3>
              <p>Access on mobile, tablet, or desktop</p>
            </div>
            <div className={styles.featureCard}>
              <i className="fas fa-shield-alt"></i>
              <h3>Secure Payment</h3>
              <p>100% secure transactions via Instamojo</p>
            </div>
          </div>
        </div>
      </section>

      {/* How to Buy Section */}
      <section className={styles.howToBuySection}>
        <div className={styles.container}>
          <div className={styles.howToBuyCard}>
            <h2>How to Buy E-Books?</h2>
            <div className={styles.steps}>
              <div className={styles.step}>
                <span className={styles.stepNumber}>1</span>
                <p>Click on "Buy Now" button for your selected e-book</p>
              </div>
              <div className={styles.step}>
                <span className={styles.stepNumber}>2</span>
                <p>Complete payment on Instamojo secure page</p>
              </div>
              <div className={styles.step}>
                <span className={styles.stepNumber}>3</span>
                <p>Download PDF instantly after successful payment</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EBookStore;